<template>
  <section id="view-logout"></section>
</template>

<script>
export default {
  name: "Logout",
  components: {},
  mixins: [], //unmounted
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = vm.$route.params;

      vm.$store.dispatch("App/logout");
      vm.$router.replace(
        {
          name: "Login",
          params,
        },
        () => {},
        () => {},
      );
    });
  }, //beforeRouteEnter
  beforeRouteUpdate(to, from, next) {
    next();
  }, //beforeRouteUpdate
  beforeRouteLeave(to, from, next) {
    next();
  },
  props: [], //components
  data() {
    return {};
  }, //data
  computed: {}, //methods
  watch: {}, //watch
  created() {}, //created
  mounted() {}, //mounted
  updated() {}, //updated
  unmounted() {}, //computed
  methods: {}, //beforeRouteLeave
};
</script>

<style scoped>
#view-logout {
}

@media (max-width: 767px) {
}

@media (min-width: 768px) and (max-width: 1199px) {
}

@media (max-width: 1199px) {
}

@media (min-width: 1200px) {
}
</style>
